@if (tab === 'raceWinner' && isTricastAvailable && tricastModel.length) {
    <div class="racing-post-pick">
        <div class="win-predictions">
            <span class="logo"> </span>
            <div class="display-flx">
                @for (runner of tricastModel; track $index) {
                    <div>
                        <ms-gh-trap-images [participant]="runner" [fixture]="fixture" />
                    </div>
                }
            </div>
        </div>
    </div>
}
@if (tab === 'forecast' && isForecastAvailable && forecastModel.length) {
    <div class="racing-post-pick">
        <div class="forecast-container">
            <span class="logo"> </span>
            <div class="forecast-details-betslip">
                <div class="display-flx">
                    @for (runner of forecastModel; track $index) {
                        <div class="participant-container">
                            <ms-gh-trap-images [participant]="runner" [fixture]="fixture" />
                        </div>
                    }
                </div>
                <div class="picks-container" [ngClass]="{ racingpostdisabled: isracingpostPickDisabled }">
                    <ms-race-xcast-pick
                        [marketType]="participantMarketType.Forecast"
                        [fixture]="fixture"
                        [participants]="forecastModel"
                        [pickType]="participantPickType.Forecast"
                        [enableOptionIndicator]="false"
                        [trackingSource]="trackingSource"
                        [trackingOptions]="getTrackingOptions()"
                        [optionGroup]="optionGroup"
                        [participantOptionGroups]="participantOptionGroups"
                        [ngClass]="
                            isButtonDisabled(false, true)
                                ? 'forecast-tricast-button odds-info ms-selectable-pick disabled'
                                : 'forecast-tricast-button odds-info ms-selectable-pick'
                        "
                        (selected)="pickSelected($event)">
                        @if (!isButtonDisabled(false, true)) {
                            <div class="forecast-tricast-info">
                                @switch (isForecastSelected) {
                                    @case (false) {
                                        <span>
                                            @if (fixture.sport.id === sport.Greyhounds) {
                                                {{ sitecore.greyhoundRacing.messages.RacingpostForecast }}
                                            } @else {
                                                {{ sitecore.horseRacing.raceDetails.RacingpostForecast }}
                                            }
                                        </span>
                                    }
                                    @case (true) {
                                        <span>{{ sitecore.horseRacing.raceDetails.RacingpostForecastSelected }}</span>
                                    }
                                }
                            </div>
                        }
                        @if (isButtonDisabled(false, true)) {
                            <div class="lock">
                                <vn-icon class="lock-icon" size="13" name="theme-locked-i" />
                            </div>
                        }
                    </ms-race-xcast-pick>
                </div>
            </div>
        </div>
    </div>
}
@if (tab === 'tricast' && isTricastAvailable && tricastModel.length) {
    <div class="racing-post-pick">
        <div class="forecast-container">
            <span class="logo"> </span>
            <div class="forecast-details-betslip">
                <div class="display-flx">
                    @for (runner of tricastModel; track $index) {
                        <div class="participant-container">
                            <ms-gh-trap-images [participant]="runner" [fixture]="fixture" />
                        </div>
                    }
                </div>
                <div class="picks-container" [ngClass]="{ racingpostdisabled: isracingpostPickDisabled }">
                    <ms-race-xcast-pick
                        [fixture]="fixture"
                        [participants]="tricastModel"
                        [marketType]="participantMarketType.Tricast"
                        [pickType]="participantPickType.Tricast"
                        [enableOptionIndicator]="false"
                        [trackingSource]="trackingSource"
                        [trackingOptions]="getTrackingOptions()"
                        [optionGroup]="optionGroup"
                        [participantOptionGroups]="participantOptionGroups"
                        [ngClass]="
                            isButtonDisabled(true, true)
                                ? 'forecast-tricast-button odds-info ms-selectable-pick disabled'
                                : 'forecast-tricast-button odds-info ms-selectable-pick'
                        "
                        (selected)="pickSelected($event)">
                        @if (!isButtonDisabled(true, true)) {
                            <div class="forecast-tricast-info">
                                @switch (isTricastSelected) {
                                    @case (false) {
                                        <span>
                                            @if (fixture.sport.id === sport.Greyhounds) {
                                                {{ sitecore.greyhoundRacing.messages.RacingpostTricast }}
                                            } @else {
                                                {{ sitecore.horseRacing.raceDetails.RacingpostTricast }}
                                            }
                                        </span>
                                    }
                                    @case (true) {
                                        <span>{{ sitecore.horseRacing.raceDetails.RacingpostTricastSelected }}</span>
                                    }
                                }
                            </div>
                        }
                        @if (isButtonDisabled(true, true)) {
                            <div class="lock">
                                <vn-icon class="lock-icon" size="13" name="theme-locked-i" />
                            </div>
                        }
                    </ms-race-xcast-pick>
                </div>
            </div>
        </div>
    </div>
}
